import { SUBMIT_EULA_ASYNC } from './constants'

export const submitEULA = (type, eulaVersion) => ({
  type: SUBMIT_EULA_ASYNC.INITIATE,
  payload: { type, eulaVersion },
})
export const submitEULASuccess = (data) => ({
  type: SUBMIT_EULA_ASYNC.SUCCESS,
  payload: { data },
})
export const submitEULAError = (error) => ({
  type: SUBMIT_EULA_ASYNC.ERROR,
  error,
})

export default {
  submitEULA,
}
